import { render, staticRenderFns } from "./view-group.vue?vue&type=template&id=77b0468e&scoped=true&"
import script from "./view-group.vue?vue&type=script&lang=js&"
export * from "./view-group.vue?vue&type=script&lang=js&"
import style0 from "./view-group.vue?vue&type=style&index=0&id=77b0468e&scoped=true&lang=css&"
import style1 from "./view-group.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0468e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
